
import React, {  useContext, useState, useEffect } from 'react';
import { fetchpdf } from '../../data/Contentapi';
import { MyContext } from '../../globalContext';
import { getConfig } from "./../../loadconfig";
import PrintIcon from '@mui/icons-material/Print';
import { useTranslation } from 'react-i18next';
import trackClick from '../../data/ClickTracking';
import { commonPublishEvent } from '../../utils/PublishEventMethod';
import {CircularProgress } from '@mui/material';

const ProviderSearchDownload = () => {
  const [showDownloadProgress, setShowDownloadProgress] = useState(false);
    const { searchFilter, searchCriteria, languageData, address, jwtToken, getSessionIdData  } = useContext(MyContext);    
    const { t } = useTranslation();
    const [pdfDetails, setPdfDetails] = useState("");
    let config = getConfig();
    const mycontext = useContext(MyContext);
   

    useEffect(() => {  
     
       
      setPdfDetails({ ...searchCriteria, viewLanguage: languageData });
      
    
    }, [languageData]);
   

  const downloadPdf = async (event) => {
    try {
      event.preventDefault();
      setShowDownloadProgress(true);
      let criteriaset = {};
      Object.assign(criteriaset, pdfDetails);

     
          if(searchFilter && Object.keys(searchFilter).length > 0) {
              Object.assign(criteriaset, searchFilter);
              
          }
          if(criteriaset["zipCode"] && criteriaset["zipCode"].length > 0) {
            delete criteriaset["city"];
            delete criteriaset["state"];
        }
      
       
      // searchCriteria["viewLanguage"] = languageData;
      // Replace with your service URL
      const response = await fetchpdf(config.PROVIDER_SEARCH_DOWNLOAD_URL, criteriaset ,mycontext);
      console.log('Response got');
      const blob = response; //await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'providerSearch.pdf'; // Set the file name
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setShowDownloadProgress(false);
      trackClick("Provider Search", "Download Results", searchCriteria.searchDisplayString, languageData);
    } catch (error) {
      setShowDownloadProgress(false);
      console.error('Error downloading the PDF:', error);
    }
   
    let eventData = {
      "Locale": languageData,
      "ReCaptcha response" : { "error-codes" : [ { "value" : "invalid-keys" } ] }, 
      "ReCaptcha version":"V3",
      "Zip Code": address.zipCode,
      "Product Code": searchCriteria.productCodeList,
      "Provider Type List": searchCriteria.providerTypeList,
      "Search String": searchCriteria.searchDisplayString,
      "Code Group List": searchCriteria.codeGroupList,
      "Client Account Number List": searchCriteria.clientAccountNumberList
}
 await commonPublishEvent("Provider Search Printer Friendly", eventData, jwtToken, getSessionIdData())
  };
 
  return (
    <div className="linkBoxResp width-30">    
   < PrintIcon style={{ verticalAlign: "middle", color: "#007839" }} />  <a href="#" className="results-link "  onClick={downloadPdf} > {t(`printerfriendly`)}</a>
    <CircularProgress data-testid='loading-circle' color="primary" style={{ verticalAlign: "middle", width: '20px', height: '20px', marginLeft:"5px", display: !showDownloadProgress && "none" }}  />
    </div>
  );
};
 
export default ProviderSearchDownload;